import React from 'react';
import styles from './styles/Page.module.css';

export default function TermsEnglish() {
  return (
    <>
      <div className={styles.page}>
        <h1 className={styles.page_title}>GENERAL TERMS AND CONDITIONS</h1>
        <div className={styles.date}>Version dated: September 21st, 2023</div>

        <p className={styles.title}>
          <strong>
            1. Definitions
          </strong>
        </p>

        <div className={styles.table}>
          <div className={styles.row}>
            <div className={styles.left}>Assets</div>
            <div className={styles.right}>
              Refers to the information and documents, of whatever nature, held and deposited in an encrypted manner by the Customer in their User Account.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              OSTREON Webapp or Webapp
            </div>
            <div className={styles.right}>
              Refers to the software operated in a Software as a Service (SaaS) mode, facilitating the transmission, and where applicable, the automated and secure transmission of Assets chosen by the Customer, based on selected criteria, to Beneficiaries unilaterally determined by the Customer.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>Beneficiary(ies)</div>
            <div className={styles.right}>
              Refers to natural persons, over the age of 18 and legally competent, designated by the Customer from their Customer Account, who may potentially access the Customer's Assets.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>Terms and Conditions</div>
            <div className={styles.right}>
              'Refers to these general terms and conditions of use and services.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>Customer</div>
            <div className={styles.right}>
              Refers to any legal adult with the capacity to enter into a contract or any legal entity, represented by an individual with the capacity to represent and bind said entity, who subscribes to a subscription for the purpose of availing OSTREON's Services for non-professional purposes, or who benefits from a Trial Offer.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              User Account
            </div>
            <div className={styles.right}>
              Refers to the account that every User must create in order to avail of the Services provided by OSTREON or to subscribe to a subscription. The Customer Account may also be referred to as the user account or the account on the OSTREON Application.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>Personal Data</div>
            <div className={styles.right}>
              'Refers to personal data as defined in Article 4.1 of the General Data Protection Regulation or 'GDPR'.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>Trusted Advisor</div>
            <div className={styles.right}>
              Refers to any individual or legal entity whom the Customer may optionally designate due to their knowledge of the Assets, with the intent that theyprovide assistance to the Beneficiaries as needed.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Confidential Information
            </div>
            <div className={styles.right}>
              Refers to any information, in whatever form and of whatever nature, whether protectable or not, to which the Parties may have access in the course of executing these terms, and which has not fallen into the public domain, unless with prior and explicit authorization from the other Party.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Notifications
            </div>
            <div className={styles.right}>
              Refers to the messages sent by OSTREON, whether to Customers, Beneficiaries, and potentially to trusted advisors.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Trial Offer
            </div>
            <div className={styles.right}>
              Refers to the offer presented by OSTREON providing access, free of charge and for a limited duration of maximum 3 months, to the Services provided by OSTREON.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              OSTREON
            </div>
            <div className={styles.right}>
              Refers to Ostreon Cybersecurity, a simplified joint-stock company with a capital of €5,000, registered with the Nanterre Trade and Companies Registry under the number 920 541 448, with its registered office located at 13 T rue Auguste Gervais, 92130 Issy-les-Moulineaux.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Privacy Policy
            </div>
            <div className={styles.right}>
              Refers to OSTREON's privacy policy accessible at the following URL: <a href="https://ostreon.io/privacy-policy/en">https://ostreon.io/privacy-policy/en</a>.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>Services</div>
            <div className={styles.right}>
              Refers to the service provisions provided by OSTREON, within the framework of the Application, as described in the article 'The Services provided by OSTREON'.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Website
            </div>
            <div className={styles.right}>
              Refers to OSTREON's website accessible at the URL ostreon.io or any other URL that may replace the aforementioned.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              User
            </div>
            <div className={styles.right}>
              refers to any individual or legal entity browsing the Site, including the Beneficiaries.
            </div>
          </div>
        </div>

        <p className={styles.title}>
          <strong>
            2. The Website
          </strong>
        </p>

        <p>
          The website, edited and operated by OSTREON, aims to provide the User with information regarding OSTREON's activities and the Services offered by OSTREON, as well as access to the Services provided by OSTREON.
        </p>

        <p className={styles.title}>
          <strong>
            3. Purpose and Scope of the Terms and Conditions
          </strong>
        </p>

        <p>
          These Terms and Conditions govern, to the exclusion of any other document, the relations between OSTREON and:
          <ul>
            <li>
              Users of the Website;
            </li>
            <li>
              Customers who have subscribed to OSTREON's Services, whether or not benefiting from a Trial Offer.
            </li>
          </ul>
        </p>

        <p>
          OSTREON reserves the right to modify its Terms and Conditions at any time. The applicable Terms and Conditions are those in effect on the date when the User browses the Website and/or when the User subscribes to OSTREON's Services.
        </p>
        <p>
          The Terms and Conditions are made available to all Users at the bottom of the Website page where they can be directly consulted at any time. Every User has the ability to save and print the Terms and Conditions using the standard functionalities of their browser or computer.
        </p>
        <p>
          Before subscribing to OSTREON's Services, the User is encouraged to review the Terms and Conditions and to accept them unconditionally. This acceptance of the Terms and Conditions, formalized by a validation click, gives the Terms and Conditions electronic contractual value and entails full and complete adherence and acceptance of the Terms and Conditions.
        </p>
        <p>
          The Terms and Conditions are written in the French language. In the event that they are translated into one or more foreign languages, only the French text would be authoritative in the event of a dispute.
        </p>
        <p>
          OSTREON provides Users, in addition to these Terms and Conditions, with user guides to offer more details about the operation of the Services. These guides are accessible at the following URL: <a href="https://ostreon.io/help-center">https://ostreon.io/help-center</a>.
        </p>

        <p className={styles.title}>
          <strong>
            4. Access to the website
          </strong>
        </p>

        <p>
          The Website is freely accessible to anyone with internet access from the following devices: computer, tablet, or smartphone.
        </p>
        <p>
          The User ensures that the computer configuration they use is virus-free, in proper working condition, and that their browser allows secure access to the Website.
        </p>
        <p>
          The User bears the costs of using the remote communication technique utilized and its access means.
        </p>
        <p>
          OSTREON cannot guarantee uninterrupted and error-free operation of the Website and/or Application. Similarly, OSTREON's liability cannot be invoked for technical issues related to hardware, software, or the internet network that might cause malfunctions and/or temporary or permanent interruptions of the Website and/or Application.
        </p>
        <p>
          OSTREON reserves the right, at its sole discretion, with or without notice, to suspend, interrupt, or limit access to all or part of the Website and/or Application, especially for update purposes.
        </p>
        <p>
          In case of access difficulties, the User can send a request for assistance to the following email address: <a href="mailto:support@ostreon.io">support@ostreon.io</a>. OSTREON commits to providing a response to this request within forty-eight (48) working hours, namely from Monday to Friday, 9 am to 6 pm (France time).
        </p>

        <p className={styles.title}>
          <strong>
            5. Use of the Website
          </strong>
        </p>

        <p>
          The User commits to using the Website for their personal use, in accordance with the provisions set out in the Terms and Conditions and applicable law.
        </p>
        <p>
          The User refrains from: <br />
          <ul>
            <li>from using the Website, the Application, and the Services in an abusive or fraudulent manner, especially for engaging in illegal activities or infringing upon the rights or security of third parties;</li>
            <li>
              from undertaking actions or deeds that might disrupt public order or violate prevailing laws and regulations;
            </li>
            <li>
              from attempting to access, without authorization, the computational or organizational means related to the Website that might disturb its access or usage;
            </li>
            <li>
              from infringing upon OSTREON's intellectual property rights and/or from reselling or attempting to resell the Services to third parties;
            </li>
            <li>from selling, copying, reproducing, renting, lending, distributing, transferring, or granting sublicenses, for any content appearing on the Website, or from decompiling, disassembling, modifying, displaying in a user-readable format, attempting to uncover any source code, or using any software that activates or comprises any part of the Website or the Application;</li>
            <li>
              from any form of use of the Services, in any way, with the intent to design, produce, disseminate, or market competing Services to those of OSTREON.
            </li>
          </ul>
        </p>

        <p className={styles.title}>
          <strong>
            6. Services provided by OSTREON
          </strong>
        </p>

        <p>
          <strong>Description of Services.</strong>
          OSTREON offers an online service in a SaaS mode, enabling Customers to send, and where applicable, transmit, in an automated and secure manner, Assets selected by the Customer based on specific criteria and to Beneficiaries exclusively determined by the Customer. The Services provided by OSTREON are based on the 'zero trust and zero knowledge' principle: the Assets are encrypted when sent to OSTREON's servers and therefore cannot be read by OSTREON.
        </p>
        <p>
          <strong>Access/Availability of Services.</strong>
          OSTREON commits to ensuring that the Services are accessible 24/7. Given the technical uncertainties inherent in using the internet network, OSTREON disclaims all liability in the event of potential slowdowns or unavailability of the Services. Furthermore, OSTREON reserves the right to wholly or partially suspend access to the Services to perform maintenance operations or upgrades to the Services. When feasible, particularly in the event of a planned maintenance operation, OSTREON will notify the Customer in advance by any means. As part of its due diligence obligation, OSTREON exerts its best efforts to minimize the unavailability of the Services.
        </p>
        <p>
          <strong>Security Measures.</strong>
          OSTREON implements technical and organizational measures, outlined in the Privacy Policy, to prevent any fraudulent access to the Assets. The Customer remains responsible for the protection and backup of the Assets.
        </p>

        <p className={styles.title}>
          <strong>
            7. Access to the service - User Account
          </strong>
        </p>

        <p>
          <strong>Creation of a Customer Account.</strong>
          Access and use of the Services necessitate the prior establishment of a Customer Account. To create a Customer Account, the Customer must provide the following details: email address, first name, and last name. The Customer must also set a password and accept the Terms and Conditions as well as the Privacy Policy. The Customer finalizes the creation of their Customer Account by confirming their email address through an activation link sent to the said email address. A Customer Account cannot be transferred, assigned, or shared. The Customer Account is not shared with the Beneficiaries.
        </p>
        <p>
          <strong>Access to the Customer Account.</strong>
          Once the Customer Account is created, the Customer logs into their Customer Account by visiting the login page and entering their email address, previously set password, and a one-time use code (OTP). It is the Customer's responsibility to ensure the confidentiality of their login details for the Customer Account.
        </p>
        <p>
          <strong>
            Use of the Customer Account.
          </strong>
          All Services are delivered through the Customer Account, which particularly allows the Customer to configure their Assets, Beneficiaries, and Notifications. The Customer alone is responsible for choices regarding the Beneficiaries, the priority order of the Beneficiaries, the Assets, and the Notifications.
        </p>
        <p>
          <strong>Beneficiaries' Access to Assets.</strong>
          It's the sole responsibility of the Customer to determine (i) the Beneficiaries and assign them a priority level of 1 or 2 and (ii) the Facilitators. If the Customer no longer responds to their Notifications, an activation email is sent to the concerned Beneficiaries at a set frequency, approximately every three (3) days, then around every fourteen (14) days for a six (6) month period, unless the Beneficiary successfully logs into the OSTREON Application during this timeframe. Following this six (6) month period, the Beneficiary's access is revoked.
        </p>
        <p>
          It is solely the Beneficiary's responsibility to log into the Application upon receipt of the activation email. Beneficiaries access the Assets through a dedicated portal on the OSTREON Application, contingent on full acceptance of these Terms and Conditions. The Beneficiary will access the Assets based on the Customer's decisions but won't have access to the Customer Account.
        </p>
        <p>
          Under no circumstances can OSTREON's liability be sought in the event of a failure to connect to the Application, or the sending and/or transmission of Assets to the Beneficiary, attributable entirely or in part to the Customer or the Beneficiary, especially due to the Beneficiary's failure to activate their access, classification of OSTREON's emails as spam, failure to check spam, or a Customer error in the Beneficiary-related details.
        </p>

        <p className={styles.title}>
          <strong>
            8. Subscription to the Services - Duration - Termination
          </strong>
        </p>

        <p>
          <strong>Trial Offer.</strong>
          The duration of the Trial Offer is limited to a maximum of three (3) months, during which OSTREON's Services may be used without subscribing to a plan. A User can benefit from only one unique Trial Offer.
        </p>
        <p>
          Unless otherwise mentioned in the Terms and Conditions and excluding Article 9, provisions applicable to the Customer are binding on Customers utilizing the Trial Offer.
        </p>
        <p>
          At the end of the Trial Offer, if a subscription plan with OSTREON is not chosen, OSTREON’s Services will no longer be accessible. The Customer retains the ability to log into their Customer Account, access, or delete their Assets, but will be unable to perform any other action, especially (i) modifying or adding additional Assets and (ii) activating or altering the Notification system.
        </p>
        <p>
          After twenty-four (24) months of inactivity following the end of the Trial Offer, access to the Customer Account will be revoked, and all associated data, including the Assets, will be deleted. This revocation will be preceded by informative emails sent by OSTREON concerning the upcoming revocation. At any time, during or after the Trial Offer, Users have the option to subscribe to a plan using the same email address, in accordance with the Terms and Conditions in effect on the subscription day.
        </p>
        <p>
          <strong>Subscription to a Plan.</strong>
          OSTREON offers the Services in the form of subscriptions, with varying durations based on the chosen package. At any given time, a customer can have only one active subscription. The subscription becomes final and is deemed formalized once the Customer receives a subscription confirmation.
        </p>
        <p>
          <strong>Duration.</strong>
          Customers can choose their subscription duration from those offered by OSTREON.
        </p>
        <p>
          <strong>Automatic Renewal of Subscriptions.</strong>
          All subscriptions renew automatically. One (1) month before the subscription's anniversary date, a reminder email is sent to the Customer, suggesting they log in and confirm their payment details. A second reminder email is sent one (1) week before the anniversary date.
        </p>
        <p>
          <strong>Subscription Change.</strong>
          Customers can choose to upgrade to a longer subscription plan. In such cases, the added duration will be appended to the previously chosen subscription duration. If the Customer wishes to receive a refund for the unused part of their previous subscription, they must contact OSTREON at the following email: <a href="mailto:support@ostreon.io">support@ostreon.io</a>.
        </p>
        <p>
          <strong>
            Customer's Right to Withdraw (excluding Trial Offer).
          </strong>
          As per Articles L221-18 and subsequent of the Consumer Code, the Customer has a right to withdraw without justification within fourteen (14) days from the subscription date. If the fourteen (14) days end on a Saturday, Sunday, public holiday, or non-working day, it's extended to the next working day. To exercise this right, the Customer must explicitly notify OSTREON (using the withdrawal form in Annex 1) at the following address: <a href="mailto:support@ostreon.io">support@ostreon.io</a> . OSTREON will process the refund within fourteen (14) days of the withdrawal notification using the same payment method the Customer used for the subscription.
        </p>
        <p>
          <strong>Customer's Legal Warranty of Conformity (excluding Trial Offer).</strong>
          If the Service provided by OSTREON does not conform to what the Customer subscribed to, the Customer can file a complaint with OSTREON within two (2) years, in line with Articles L.224-25-12 and following of the Consumer Code, as reproduced in Annex 2.
        </p>
        <p>
          <strong>Termination by the Customer (excluding Trial Offer).</strong>
          Customers can terminate their subscription anytime without charge via their Customer Account or by sending a request to support@ostreon.io. Termination should be initiated at least seven (7) days before the next scheduled payment date. If terminated within this period, the automatic renewal will be disabled. Customers can still enjoy OSTREON's Services until the initially anticipated expiration date of the subscription. No refunds will be issued.
        </p>
        <p>
          <strong>Consequences of Contract Termination for the Customer (excluding Trial Offer).</strong>
          The end of a subscription results in the termination of Services relevant to the subscription on the last day of the paid subscription period. Thereafter, Customers can still log into their Customer Account and access or delete their Assets but will be unable to (i) modify or add additional Assets, and (ii) modify or activate the Notification system. After twenty-four (24) months of inactivity, the Customer Account and Assets linked to the Customer Account will be deleted.
        </p>
        <p>All provisions herein that, by their nature, are meant to survive the termination of the subscription will outlast this termination, regardless of its cause.</p>

        <p className={styles.title}>
          <strong>
            9. Financial Terms
          </strong>
        </p>

        <p>
          <strong>Price.</strong>
          Subscription prices are displayed directly on the website, in euros inclusive of all taxes, and are clearly and precisely indicated before the contract's conclusion.
        </p>
        <p>
          <strong>
            Price Adjustments for Products.
          </strong>
          OSTREON reserves the right to alter, at any time and without prior notice, the price of the subscriptions offered. The applicable price will be that stated on the date of the Customer's subscription.
        </p>
        <p>
          <strong>Billing Methods.</strong>
          The subscription is billed in full and annually at the time of subscription. An invoice will be automatically sent to the Customer (excluding Trial Offer) via email after the subscription payment. If the invoice isn't received, the Customer is encouraged to send a request to the following email address: <a href="mailto:support@ostreon.io">support@ostreon.io</a>.
        </p>
        <p>
          <strong>Payment Methods.</strong>
          The Customer can pay for the subscription using the following payment methods:
          <ul>
            <li>
              Credit Card;
            </li>
            <li>
              Google Pay;
            </li>
            <li>
              Apple Pay;
            </li>
            <li>
              PayPal.
            </li>
          </ul>
        </p>
        <p>
          The payment and billing service provider is Stripe ( <a href="https://stripe.com">https://stripe.com</a> ).
        </p>
        <p>
          For the subscription of an 'unlimited duration' plan, Customers (excluding Trial Offer) wishing to make a payment via bank transfer can contact OSTREON at <a href="mailto:support@ostreon.io">support@ostreon.io</a> to obtain OSTREON's bank details. The Customer should include their identifier in the bank transfer's 'comment' section and notify OSTREON once the bank transfer is completed, providing the transaction ID. The Customer must then await approval for a maximum period of seven (7) days until payment is received.
        </p>

        <p className={styles.title}>
          <strong>
            10. Assets
          </strong>
        </p>

        <p>
          <strong>Asset Encryption.</strong>
          Given that the Assets are encrypted locally on the customer browser before being sent to OSTREON's servers, OSTREON cannot access the contents of the Assets under any circumstances.
        </p>
        <p>
          <strong>Ownership of Assets.</strong>
          The Customer remains the sole proprietor of the Assets.
        </p>
        <p>
          <strong>Customer Guarantees.</strong>
          The Customer ensures and guarantees they either hold the rights or have procured the necessary authorizations to use the Assets and transmit the Personal Data, notably that of the Beneficiaries, essential for sending Notifications. As a result, the Customer absolves OSTREON of any liability in case of non-compliance of the Assets and/or the relayed information, including Personal Data, with prevailing laws, regulations, public order, or the Customer's needs.
        </p>
        <p>
          Licensing of Assets. Subject to confidentiality provisions, the Customer grants OSTREON a non-exclusive, royalty-free license for the use of the Assets for the sole purpose of executing the contract between the Customer and OSTREON.
        </p>
        <p>
          OSTREON's Security Commitments. OSTREON commits to implementing suitable technical measures to ensure the safety and confidentiality of the Assets. OSTREON also establishes technical and organizational measures designed to prevent any fraudulent access or use of the Assets and to alert the Customer of any loss, alteration, or destruction of Assets.
        </p>
        <p>
          Customer's Responsibility. The Customer remains responsible for the protection and backup of the Assets. It is incumbent upon the Customer to execute regular backups of their Assets on any available media. OSTREON disclaims any liability in this regard.
        </p>
        <p>
          Asset Quality and Integrity. The Customer is exclusively responsible for the quality, accuracy, integrity, legality, and relevance of the Assets. OSTREON has no access to the Asset contents and can under no circumstances undertake potential restorations of any or all of the Assets in the event of unexpected destruction, disappearance, or alteration upon the Customer's request.
        </p>
        <p>
          Indemnification. The Customer indemnifies OSTREON on first demand against any damage arising from any third-party claim due to a breach of this warranty.
        </p>
        <p>
          Definition of Assets. The term 'Assets' does not encompass information relating to the Customers, their Beneficiaries, or Facilitators, provided by the Customer in the context of using the Services and essential for creating and administratively managing their Customer Account or their subscription (e.g., identification data, contact data, accounting data, invoices).
        </p>

        <p className={styles.title}>
          <strong>
            11. Responsibility
          </strong>
        </p>

        <p>
          The services offered by OSTREON are provided 'as is'. OSTREON can exempt itself wholly or partly from its liability by proving that the non-execution or improper execution of the Services is attributable either to the Customer or due to the unforeseeable and insurmountable action of a third party. OSTREON will not be deemed responsible or in default for any delay or non-performance resulting from the occurrence of force majeure as typically recognized by French jurisprudence.
        </p>
        <p>
          The User is solely responsible for the equipment and internet connection used to access the Services. Any total or partial inability to use the Services, especially due to the incompatibility of the Customer's or Beneficiaries' hardware, can not give rise to any compensation, refund, or challenge to OSTREON's liability, except in the case of non-compliance and/or defectiveness provided for by the Consumer Code.
        </p>
        <p>
          All Users are solely responsible for using the Website. The Customer is solely responsible for the choice and use of the Services, the selection and accuracy of Beneficiary-related information, as well as the choice and preservation of the Assets. A Beneficiary, who has accessed the Assets, is solely responsible for these Assets and their use. OSTREON disclaims any liability regarding the content of these Assets.
        </p>
        <p>
          OSTREON is a SaaS software publisher and does not provide any advisory services in any form or nature. Under no circumstances does the use of the Application or Services guarantee compliance of the Assets and choice of Beneficiaries with the applicable regulations in civil law and succession law, which is the Customer's responsibility. OSTREON's liability cannot, therefore, be engaged on this basis. It is reminded to the Customer and the Beneficiaries that they can be assisted by any chosen professional third-party, including regulated professions (lawyer, notary, etc.), to make the most suitable choices for the preservation of their interests. These professionals can notably be designated as Facilitators within the Services.
        </p>
        <p>
          The Customer ensures and verifies the accuracy and completeness of the information provided during the creation of their Customer Account and when using the Services. OSTREON disclaims any liability in case of potential input errors by the Customer or failure to update the Assets, Notifications, and information related to the Customer or their Beneficiaries, including Personal Data. In particular, OSTREON waives any responsibility in case of deficiency, error, or inaccuracy attributable to the Customer concerning the Assets, Notifications, or Beneficiaries.
        </p>
        <p>
          OSTREON disclaims all responsibility in the event of a lack of response from Beneficiaries to Notifications.
        </p>
        <p>
          In the event of the initiation of collective proceedings, the Customer acknowledges that the continuation of the Service' provision will not depend on OSTREON's will but on the appointed administrator. Hence, they cannot challenge OSTREON's liability in this regard.
        </p>

        <p className={styles.title}>
          <strong>
            12. Intellectual property rights
          </strong>
        </p>

        <p>
          OSTREON's Intellectual Property on the Site Content: The Site, including all its content (texts, images, diagrams, graphics, brands, logos, designs, photographs, databases, software, etc.), including its structure, is protected by intellectual property law and subject to applicable regulations. It remains the exclusive property of OSTREON. All related rights are reserved globally for the duration of the intellectual property rights.
        </p>
        <p>
          Any representation, reproduction, translation, adaptation, or arrangement of the Site or its content without OSTREON's prior written consent is prohibited. Not taking action against a user involved in a copyright infringement act cannot be seen as OSTREON's acceptance of such use.
        </p>
        <p>
          Usage beyond the rights mentioned can only happen with OSTREON's explicit, prior written authorization by sending a request to <a href="mailto:support@ostreon.io">support@ostreon.io</a>. OSTREON's non-response to this written request cannot imply authorization.
        </p>
        <p>
          OSTREON's Right of Use of the Application: OSTREON retains all intellectual property rights regarding the Application, Services, and all documents of any nature communicated by OSTREON.
        </p>
        <p>
          For Service use, OSTREON grants the Client a non-exclusive, non-transferable, non-assignable, without sublicensing rights, access, and use of the OSTREON Application within the present agreement's limits.
        </p>
        <p>
          The Client commits to using the OSTREON Application and Services for personal use, excluding all commercial purposes. The Client pledges not to:
          <ul>
            <li>
              Copy, reproduce, distribute, modify, or adapt the Application in anymanner;
            </li>
            <li>
              Translate or transcribe the OSTREON Application into any other language or add any non-compliant object;
            </li>
            <li>
              Decompile or reverse-engineer the Application beyond legal limits;
            </li>
            <li>
              Market or transfer in any manner the Application or Services similar to those offered by OSTREON;
            </li>
            <li>
              Allow unauthorized access to the Application;
            </li>
            <li>
              Grant any rights or establish guarantees over the Application or Services for third parties;
            </li>
            <li>
              Integrate the Application into other digital or IT works or products;
            </li>
            <li>
              Introduce into the Application any viruses, Trojans, or any disruptivesoftware;
            </li>
            <li>
              Try to hack or perform any intrusive action on any part of the Application without OSTREON's written consent.
            </li>
          </ul>
        </p>
        <p>
          The current provisions shouldn't be seen as granting any intellectual property right to the Client or broader User. The Client commits to respecting all of OSTREON's intellectual property rights. The Client ensures the Beneficiary respects OSTREON's intellectual property rights. Any violation of this article might result in the termination of Services by OSTREON.
        </p>
        <p>
          The Client will immediately inform OSTREON about any reproduction, imitation, or infringement of the Services.
        </p>
        <p>
          These provisions apply to Beneficiaries using the OSTREON Application via the dedicated access portal.
        </p>

        <p className={styles.title}>
          <strong>
            13. Confidentiality
          </strong>
        </p>

        <p>
          Throughout the duration of the agreement, both Parties commit to maintaining the confidentiality of any Confidential Information.
        </p>
        <p>
          The Parties shall have no obligation and shall not be subject to any restrictions with respect to any information for which they can demonstrate that it has entered the public domain as of its disclosure date, that it was already known to the other Party, that it was received from a third party authorized to disclose it lawfully without restriction or breach of this agreement, or that a Party is required to disclose due to a legal or regulatory obligation, a court order, or upon the request of a public authority.
        </p>

        <p className={styles.title}>
          <strong>
            14. Personal Data Protection
          </strong>
        </p>

        <p>
          <strong>Data Controller.</strong>
          As the data controller, OSTREON commits to complying with the Regulations related to the protection of Personal Data in accordance with the Privacy Policy.
        </p>
        <p>
          <strong>Sub-processing.</strong>
          Within the framework of providing Services and except for individual Users acting within the context of strictly personal or domestic activities, OSTREON may implement, as a sub-processor, on behalf of the Client, acting as a data controller, the personal data processing operations defined below.
        </p>

        <p className={styles.title}>
          <strong>
            14.1. Description of the Processing
          </strong>
        </p>

        <p>
          OSTREON is authorized to process on behalf of the Client the Personal Data necessary to provide the Services, with the understanding that:
          <ul>
            <li>
              the nature and purpose of the processingare: the provision of the Services. If the customer entrusts OSTREON with processing related to other purposes, the Client must specify this in writing;
            </li>
            <li>
              the categories of individuals concerned are the Users, the Beneficiaries, and the trusted advisors;
            </li>
            <li>
              the Personal Data processed are: first name, last name, email address, billing information (physical address) and payment details to complete the transaction.
            </li>
          </ul>
        </p>

        <p className={styles.title}>
          <strong>
            14.2. Obligations of OSTREON as a Data Processor
          </strong>
        </p>

        <p>
          OSTREON commits to:
          <ul>
            <li>
              processing Personal Data solely for the specific purpose(s) for which it has been subcontracted;
            </li>
            <li>
              handling Personal Data in accordance with the description of the Services. If OSTREON believes that an instruction constitutes a breach of the GDPR or any other provision of the law of the European Union or the law of the Member States relating to the protection of Personal Data, it will immediately inform the Customer. A documented and written refusal from OSTREON does not grant the Customer the right to terminate the contract, unless the latter undertakes to bear its liability towards OSTREON. Furthermore, if OSTREON is obliged to transfer Personal Data to a third country or an international organization, under the law of the European Union or the law of the Member State to which it is subject, it must inform the Customer of its legal obligations prior to processing, unless the applicable law prohibits such disclosure for significant reasons of publicinterest;
            </li>
            <li>
              ensuring the confidentiality and security of the Personal Data processed;
            </li>
            <li>
            ensuring that those authorized to process Personal Data:
              <ul>
                <li>
                  are solely those whose roles require access to Personal Data strictly for the execution of assigned tasks. OSTREON commits taking of modifying any internal measure in terms of internal organization or techniques to limit any disclosure of personal data to other individuals;
                </li>
                <li>
                  commit to maintaining confidentiality or are under an appropriate legal confidentiality obligation;
                </li>
                <li>
                  receive the necessary training on personal data protection. OSTREON guarantees that its employees will respect its commitments under this article;
                </li>
              </ul>
            </li>
            <li>
              taking into account, concerning its tools, products, applications, or services, the principles of data protection by design and by default.
            </li>
          </ul>
        </p>

        <p className={styles.title}>
          <strong>
            14.3. Subcontracting
          </strong>
        </p>

        <p>
          The Customer authorizes OSTREON to engage subcontractors (hereafter referred to as '<strong>Subsequent Subcontractor(s)</strong>') for specific processing activities.
        </p>
        <p>
          OSTREON ensures that the Subsequent Subcontractor provides sufficient guarantees regarding the implementation of suitable technical and organizational measures, ensuring that the processing meets the requirements of the GDPR and the commitments made in these T&Cs.
        </p>
        <p>
          OSTREON commits to using subcontractors who are: (i) established in a country within the European Union or the European Economic Area (EEA); or (ii) established in a country that has been deemed to provide an adequate level of protection by a decision of the European Commission concerning data protection regulations; or (iii) with whom OSTREON has adopted standard contractual clauses; or (iv) that provide appropriate safeguards as outlined in Article 46 of the GDPR.
        </p>
        <p>
          Personal data is hosted by OSTREON's subcontractor hosting services,STRIPE and AWS, on servers located exclusively within the territory of the European Union. A complete list of OSTREON's subcontractors is provided upon written request from the Customer. OSTREON will promptly inform the Customer of any planned changes concerning the addition or replacement of other subcontractors. The Customer has ten (10) working days from the receipt of this notification to raise objections. A lack of objection during this period is deemed acceptance by the Customer. In case of objections, OSTREON may provide responses. In the event of disagreement, OSTREON can suspend access to the Services until an agreement is reached, or until the contract is terminated by the Customer or by OSTREON. OSTREON remains fully liable to the Customer for the performance of the other Subcontractor's obligations. Under no circumstances will OSTREON be held responsible for any lack of transparency or provision of inaccurate information by the Subsequent Subcontractor.
        </p>

        <p className={styles.title}>
          <strong>
            14.4. Right to Inform the Data Subjects
          </strong>
        </p>

        <p>
          It is the responsibility of the Customer to provide information to the individuals affected by the data processing operations at the time of data collection.
        </p>

        <p className={styles.title}>
          <strong>
            14.5. Exercise of the Rights of the Data Subjects
          </strong>
        </p>

        <p>
          To the extent possible, OSTREON assists the Customer in fulfilling their obligation to respond to requests for the exercise of the rights of data subjects: right of access, rectification, erasure, and objection, right to restrict processing, right to data portability, right not to be subject to an automated individual decision (including profiling).
        </p>
        <p>
          When the data subjects exercise their rights with OSTREON, OSTREON will forward these requests upon receipt by email to the email address provided by the Customer.
        </p>

        <p className={styles.title}>
          <strong>
            14.6. Notification of Personal Data Breaches
          </strong>
        </p>

        <p>
          OSTREON commits to notifying the Customer of any personal data breach within a maximum period of forty-eight (48) hours after becoming aware of it, via email. This notification will be accompanied by any relevant documentation to enable the Customer, if necessary, to report this breach to the competent supervisory authority.
        </p>

        <p className={styles.title}>
          <strong>
            14.7. Security Measures
          </strong>
        </p>

        <p>
          OSTREON commits to implementing technical and organizational security measures to safeguard the security and confidentiality of Personal Data. The list of security measures implemented by OSTREON is available upon written request from the Customer.
        </p>

        <p className={styles.title}>
          <strong>
            14.8. Disposition of Personal Data - Reversibility
          </strong>
        </p>

        <p>
          At the end of the contract, OSTREON provides the Customer with all Personal Data transmitted in a CSV format and deletes them, subject to its legal and regulatory obligations.
        </p>

        <p className={styles.title}>
          <strong>
            14.9. Registry of Processing Activities Categories
          </strong>
        </p>

        <p>
          OSTREON declares that it maintains a written record of all categories of processing activities carried out on behalf of the Customer.
        </p>

        <p className={styles.title}>
          <strong>
            14.10. Documentation
          </strong>
        </p>

        <p>
          Upon the express and written request from the Customer, OSTREON will provide the Customer, within the limit of one (1) request per year and with a notice period of ten (10) days, the necessary documentation to demonstrate compliance with all its obligations. This documentation will also allow the performance of audits, including inspections, by the data controller or another auditor appointed by the Customer, and OSTREON will assist in these audits.
        </p>

        <p className={styles.title}>
          <strong>
            14.11. Obligations of the Customer towards OSTREON
          </strong>
        </p>

        <p>
          The Customer commits to:
          <ul>
            <li>
              Only communicate Personal Data that has been lawfully collected from the concerned individuals;
            </li>
            <li>
              Provide OSTREON with the necessary Personal Data for the performance of its role as a processor;
            </li>
            <li>
              Document in writing any instructions concerning the processing of Personal Data by OSTREON;
            </li>
            <li>
              Ensure, both prior to and throughout the duration of the processing, that OSTREON complies with the obligations set out by the GDPR;
            </li>
            <li>
              Oversee the processing, including carrying out audits and inspections of OSTREON.
            </li>
          </ul>
        </p>

        <p className={styles.title}>
          <strong>
            15. Referral to Third-Party Websites/Share Buttons
          </strong>
        </p>

        <p>
          The Website may contain links to other websites that are neither edited nor controlled by OSTREON. OSTREON cannot be held responsible for the operation, content, or any element present or obtained through these websites.
        </p>
        <p>
          The establishment of such links or the reference to any information, articles, or services provided by a third party can neither be and should not be interpreted as an express or implied endorsement by OSTREON of these websites and their elements nor their content.
        </p>
        <p>
          The Customer is advised to refer to and carefully read the rules applicable to the use of the information communicated on these websites. As OSTREON cannot perform continuous control of these links on the Website, it cannot be held responsible for any reason regarding the content of these sites.
        </p>
        <p>
          Any questions or comments related to another site should be addressed to the operators of these sites. No link to the Website is allowed without the prior explicit written permission of OSTREON.
        </p>
        <p>
          The social network share buttons present on the Website allow for the sharing of Website content through 'Share,' 'Like' buttons, on social networks such as Facebook, Twitter, LinkedIn, Instagram, etc. These social networks can collect personal data related to the Customer's browsing and associate it with the personal data they have access to, in accordance with their own terms of use and privacy policies. OSTREON has no control over and excludes all liability regarding the use of the User's personal data by these social networks.
        </p>

        <p className={styles.title}>
          <strong>
            16. Insurance
          </strong>
        </p>

        <p>
          OSTREON declares that it is insured with a reputedly solvent insurance company for all detrimental consequences of actions for which it might be held accountable under the Terms andConditions, and commits to keeping up-to-date with the payment of the corresponding premiums.
        </p>

        <p className={styles.title}>
          <strong>
            17. Subcontracting
          </strong>
        </p>

        <p>
          The Customer agrees that OSTREON may subcontract a portion of the Services to one or more third parties, provided that these third parties have the necessary expertise and skills and are subject to the same obligations as OSTREON.
        </p>

        <p className={styles.title}>
          <strong>
            18. Transfer
          </strong>
        </p>

        <p>
          OSTREON reserves the right to transfer to any company of its choice all or part of the rights and obligations arising between the Customer and OSTREON under the Terms and Conditions, and will notify the Customer in advance, in accordance with applicable law.
        </p>

        <p className={styles.title}>
          <strong>
            19. Evidence Agreement
          </strong>
        </p>

        <p>
          The electronic acceptance of the Terms and Conditions by the Customer and/or the Beneficiary, on one hand, and OSTREON, on the other hand, has the same probative value as an agreement on paper.
        </p>
        <p>
          Generally, the Customer and/or the Beneficiary acknowledges and agrees to communicate with OSTREON primarily through electronic mail, for instance, concerning information that might be sent during the execution of the Terms and Conditions.
        </p>

        <p className={styles.title}>
          <strong>
            20. Non-Waiver and Independence of Clauses
          </strong>
        </p>

        <p>
          The nullity of a contractual clause does not result in the nullity of the other clauses of the Terms and Conditions, which continue to have their effects.
        </p>

        <p>
          The fact that OSTREON does not assert any provision of the Terms and Conditions at a given time cannot be interpreted as a waiver to subsequently assert any provision of said Terms and Conditions.
        </p>

        <p className={styles.title}>
          <strong>
            21. Dispute Resolution and Applicable Law
          </strong>
        </p>

        <p>
          <strong>Applicable Law.</strong>
          The Terms and Conditions are governed by and interpreted in accordance with French law.
        </p>
        <p>
          Dispute Resolution. Prior to any legal action, with the exception of actions initiated for protective measures, the Parties agree to seek, within reasonable time limits, an amicable solution to the dispute that opposes them.
        </p>
        <p>
          <strong>Competent Jurisdictions.</strong>
          In the absence of conciliation within a period of one (1) month from the occurrence of the dispute, the Parties grant exclusive jurisdiction to the courts within the jurisdiction of the Paris Court of Appeal (France), to hear any difficulty relating to the validity, interpretation, or execution of the Terms and Conditions, notwithstanding the plurality of defendants or call for guarantee, even for urgent or protective procedures, in summary proceedings or by request.
        </p>
        <p>
          <strong>Customer Complaint (excluding Trial Offer).</strong>
          Any complaint, regardless of its nature, related to a Service must be submitted by sending an email to the following address: <a href="mailto:complaints@ostreon.io">complaints@ostreon.io</a> or through the 'contact us' page of the website.
        </p>
        <p>
          The complaint must be detailed and clearly indicate the reasons for dissatisfaction. OSTREON and the Customer commit to seeking an amicable solution to the dispute between them, it being specified that the Customer has the possibility to be assisted by the counsel of his choice (association, etc.).
        </p>
        <p>
          If the Customer decides to withdraw his complaint, he acknowledges that this withdrawal is final.
        </p>
        <p>
          <strong>Consumer Mediator.</strong>
          If, within a period of one (1) month from said complaint and despite OSTREON's efforts, the dispute persists, the Customer will have the possibility to seize the consumer mediator, in accordance with articles L.612-1 and following of the Consumer Code.
        </p>
        <p>
          The contact details of the consumer mediator are as follows: <a href="mailto:consommation@cmap.fr">consommation@cmap.fr</a>, CMAP - Service Médiation de la consommation, 39 avenue Franklin Roosevelt, 75008 Paris. In the absence of an amicable settlement within a period of one (1) month from the occurrence of the dispute, the Parties may seize the French courts, which will be the only competent ones.
        </p>
        <p>
          The European Commission has also set up a dispute resolution platform intended to collect any consumer complaints following an online purchase and then transmit them to the competent national mediators. The rights are explained <a href="https://ec.europa.eu/consumers/odr/main/?event=main.consumer.rights">here</a>, and the platform is accessible by clicking <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=FR">here</a>.
        </p>

        <div className={styles.head_title}>
          APPENDIX 1 - WITHDRAWAL FORM TEMPLATE
        </div>

        <p>
          I/we () hereby notify you () of my/our () withdrawal from the contract regarding the subscription to the below-mentioned service:
        </p>
        <p>
          Ordered on ()/received on ():
        </p>
        <p>
          Name of the customer(s) consumer(s):
        </p>
        <p>
          Address of the customer(s) consumer(s):
        </p>
        <p>
          Signature of the customer(s) consumer(s) (only if this form is notified on paper):
        </p>
        <p>
          Date:
        </p>
        <p>
          () Delete as appropriate.
        </p>

        <div className={styles.head_title}>
          ANNEX 2 - LEGAL WARRANTY OF CONFORMITY
        </div>

        <p className={styles.underlined}>
          Article L.224-25-12 of the Consumer Code:
        </p>

        <p>
          The professional provides digital content or a digital service in accordance with the contract and the criteria set out in Article L. 224-25-14.
        </p>
        <p>
          When the contract provides for a one-time supply of digital content or digital service, or a series of separate supply operations, the professional is responsible for non-conformities existing at the time of supply that appear within two years of that supply.
        </p>
        <p>
          If the contract provides that the digital content or digital service is provided continuously, the professional is responsible for non-conformities that appear during the period during which it is provided under the contract.
        </p>
        <p>
          The applicable period does not deprive the consumer of their right to updates in accordance with the provisions of Article L. 224-25-25.
        </p>
        <p>
          The professional is also responsible, within the same time frames, for non-conformities resulting from incorrect integration of digital content or the digital service into the consumer's digital environment when this was done by the professional or under its responsibility, or when the incorrect integration carried out by the consumer results from gaps in the instructions the professional provided.
        </p>
        <p>
          This warranty period applies without prejudice to Articles 2224 and following of the Civil Code. The starting point for the limitation period for the consumer's action is the day the consumer becomes aware of the non-conformity.
        </p>

        <p className={styles.underlined}>
          Article L.224-25-13 of the Consumer Code:
        </p>

        <p>
          The digital content or digital service is in conformity with the contract if it meets, where applicable, the following criteria:
        </p>
        <p>
          1° It matches the description, type, quantity, and quality, especially regarding functionality, compatibility, interoperability, or any other characteristic stipulated in the contract;
        </p>
        <p>
          2° It is fit for any special use sought by the consumer, brought to the professional's attention at the latest at the time of contract conclusion, which the latter has accepted;
        </p>
        <p>
          3° It is provided with all accessories, including packaging, installation instructions, as well as customer support, to be supplied according to the contract;
        </p>
        <p>
          4° It is updated in accordance with the contract.
        </p>

        <p className={styles.underlined}>
          Article L.224-25-14 of the Consumer Code:
        </p>

        <p>
          I.- In addition to the conformity criteria provided for in the contract, digital content or the digital service is considered compliant if it meets the following criteria:
        </p>
        <p>
          1° It is fit for the usual purpose expected of digital content or a digital service of the same type, considering, if applicable, any provisions of the law of the European Union and national law as well as all technical standards or, in the absence of such technical standards, specific codes of conduct applicable to the concerned sector;
        </p>
        <p>
          2° If applicable, it possesses the qualities that the professional presented to the consumer in the form of a trial version or preview before contract conclusion;
        </p>
        <p>
          3° It is provided in the most recent version available at the time of the contract conclusion unless otherwise agreed by the parties;
        </p>
        <p>
          4° In the case of continuous supply of digital content or a digital service over a given period, it is provided uninterrupted throughout that period;
        </p>
        <p>
          5° If necessary, it is provided with all the accessories and installation instructions, as well as customer support, which the consumer can legitimately expect;
        </p>
        <p>
          6° If applicable, it is provided with the updates that the consumer can legitimately expect, in accordance with the provisions of article L. 224-25-25;
        </p>
        <p>
          7° It matches the quantity, quality, and other features, including in terms of functionality, compatibility, accessibility, continuity, and security, which a consumer can legitimately expect from digital content or digital services of the same type, considering the nature of this content or service and the public statements made by the professional, by anyone upstream in the transaction chain, or by someone acting on their behalf, including in advertising or labeling.
        </p>
        <p>
          II.- However, the professional is not bound by all public statements referred to in the last paragraph of I if they demonstrate:
        </p>
        <p>
          1° That they were unaware and could not legitimately have been aware ofthem;
        </p>
        <p>
          2° That at the time of contract conclusion, public statements had been corrected under conditions comparable to the initial statements; or
        </p>
        <p>
          3° That the public statements could not have influenced the decision to contract.
        </p>
        <p>
          III.- The consumer cannot challenge conformity by invoking a defect concerning one or several specific features of the digital content or digital service when they were specifically informed that these deviated from the conformity criteria set out in this article, a deviation to which they expressly and separately consented at the time of contract conclusion.
        </p>

      </div>
    </>);
}